import React, { FC } from "react";
import { Heading } from "../Heading";
import { Button } from "../Button";
import { colors } from "../../styles/variables";
import { StyledContainer, StyledParagraph } from "./index.styled";
import { LocalizationQuery } from "../../types/graphql/generated";

interface PasswordUpdateRequiredProps {
  localization?: LocalizationQuery["localization"] | null;
  goToShop?: () => void;
}

export const PasswordUpdateRequired: FC<PasswordUpdateRequiredProps> = ({
  localization,
  goToShop,
}) => {
  const {
    checkYourEmailHeadingText = "Check Your Email",
    checkYourEmailContentText = "For your account's security, a password update is needed. We've sent an email with a secure link to complete this process Please check your inbox (and spam folder if needed) to proceed. Thank you for helping us keep your account safe!",
    backButtonText = "Return to shopping",
  } = localization?.portal?.password || {};

  return (
    <StyledContainer>
      <Heading level="h2" size="l" color={colors.gray900}>
        {checkYourEmailHeadingText}
      </Heading>
      <StyledParagraph>{checkYourEmailContentText}</StyledParagraph>

      {goToShop && (
        <Button type="tertiary" fullWidth onClick={goToShop} disabled={false}>
          {backButtonText}
        </Button>
      )}
    </StyledContainer>
  );
};
